import React from "react";
import { Tag, Tooltip } from "antd";
import { useSelector } from "react-redux";
import moment from "moment";
import { useSmartNavigate } from '@/hooks/use-smart-navigate';
import {
    getSpecFieldsFromSchema,
    normalizeSpecSchema,
} from '@/utils/equipment-category-spec-schema';

export const Equipment_CategoryProps = {
    title: 'Facility Category',
    description: '',
    name: 'equipmentCategory',
}

const GotoDetail = ({ id, label }) => {
    const { navigateAndCloseTabs } = useSmartNavigate();
    const handleClick = (e) => {
        e.stopPropagation();
        navigateAndCloseTabs(`/admin/equipment-category-detail/${id}`, '/admin/equipment-category-detail/');
    };
    return label
        ? <a onClick={handleClick}>{label}</a>
        : <a onClick={handleClick}><i className="fas fa-expand-arrows-alt text-lg"></i></a>;
}

const formatSpecValue = (value, type) => {
    if (value === undefined || value === null || value === '') return '-';
    if (type === 'boolean') return value ? 'Yes' : 'No';
    if (Array.isArray(value)) return value.join(', ');
    return String(value);
};

const DynamicSpecs = ({ schema }) => {
    const isPC = useSelector((state) => state.App?.isPC ?? true);
    const normalized = normalizeSpecSchema(schema);
    const fields = getSpecFieldsFromSchema(normalized);
    if (!fields.length) return <span>-</span>;

    if (!isPC) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                {fields.map((field) => (
                    <div
                        key={field.id}
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
                            gap: 10,
                            padding: '6px 0',
                            borderBottom: '1px solid #f0f0f0',
                            lineHeight: '18px',
                        }}
                    >
                        <span style={{ color: '#8c8c8c', fontWeight: 500 }}>{field.label}</span>
                        <span style={{ minWidth: 0, overflowWrap: 'anywhere' }}>
                            {formatSpecValue(normalized.values?.[field.id], field.type)}
                        </span>
                    </div>
                ))}
            </div>
        );
    }

    const renderSpecTag = (field) => (
        <Tag key={field.id} style={{ marginRight: 6 }}>
            <span style={{ fontWeight: 500 }}>{field.label}:</span>{' '}
            {formatSpecValue(normalized.values?.[field.id], field.type)}
        </Tag>
    );

    return (
        <Tooltip
            placement="topLeft"
            title={<div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>{fields.map(renderSpecTag)}</div>}
        >
            <div
                style={{
                    width: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}
            >
                {fields.map(renderSpecTag)}
            </div>
        </Tooltip>
    );
};


export const Equipment_CategoryColumns = [
    {
        title: 'key',
        dataIndex: 'id',
        key: 'id',
        editable: false,
        search: false,
        importIngore: true,
        width: '4%',
        hideInTable: true,
    },
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        search: false,
        editable: false,
        sorter: (a, b) => a.name?.localeCompare(b.name),
        formItemProps: {
            rules: [
                {
                    required: true,
                    message: 'required',
                },
            ],
        },
        render: (text, record) => (
            <GotoDetail id={record.id} label={text} />
        )
    },
    {
        title: 'Specs',
        dataIndex: 'spec_schema',
        key: 'spec_schema',
        editable: false,
        edit: false,
        search: false,
        width: '36%',
        hideMobileLabel: true,
        render: (schema) => <DynamicSpecs schema={schema} />,
    },
    {
        title: 'Life Expectancy (Years)',
        dataIndex: 'life_expectancy',
        key: 'life_expectancy',
        editable: false,
        hideInTable: window.innerWidth < 760,
        width: 150,
        align: 'right', // 数字列右对齐
        sorter: (a, b) => (a.life_expectancy || 0) - (b.life_expectancy || 0),
        formItemProps: {
            rules: [
                {
                    pattern: /^[0-9]\d*$/,
                    message: 'Must be a positive integer',
                },
            ],
        },
    },
    {
        title: 'Comment',
        dataIndex: 'comment',
        key: 'comment',
        hideInTable: window.innerWidth < 760,
        editable: false
    },
    {
        title: 'Modified Date',
        dataIndex: 'modified_date',
        key: 'modified_date',
        editable: false,
        importIngore: true,
        hideInTable: window.innerWidth < 760,
        width: 150,
        align: 'right',
        sorter: (a, b) => new Date(a.modified_date || 0) - new Date(b.modified_date || 0),
        render: (value) => {
            const date = moment(value);
            return value && date.isValid() ? date.format('YYYY-MM-DD HH:mm') : '-';
        },
    },
    // {
    //     title: '',
    //     valueType: 'option',
    //     width: '6rem',
    //     importIngore: true,
    //     render: (text, record, _, action) => (
    //         <div className={'space-around'}>
    //             <a
    //                 key="editable"
    //                 onClick={() => (action?.startEditable?.(record.id))}
    //             >
    //                 <i className="fas fa-edit text-lg"></i>
    //             </a>
    //             <GotoDetail id={record.id} />
    //         </div>
    //     ),
    // },
];
